import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import MultiSelect from './components/MultiSelect';

/**
 * Any number of the field's fixed `items`, as an array of them. Each is shown as
 * enums.<item> (enums.<enumGroup>.<item> with a group), as an Items field shows
 * its one, unless `noTranslate`.
 */
export default class DialogStaticMultiSelect extends React.Component {
    render() {
        const { field, value, onChange, error } = this.props;
        const label = (item) => {
            if (field.noTranslate) return item;
            return i18n.t(field.enumGroup ? `enums.${field.enumGroup}.${item}` : `enums.${item}`);
        };
        const mappedItems = (field?.items || []).map((str) => ({
            id: str,
            label: label(str)
        }));

        return (
            <MultiSelect
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                placeholder={i18n.t(`placeholder.${field.label}`)}
                items={mappedItems}
                // A new row's array starts out null (GridDataAdapter's default).
                value={Array.isArray(value) ? value : []}
                disabled={Boolean(field.onlyRead) || Boolean(this.props.disabled)}
                error={Boolean(error)}
                helperText={error || (field.helperText ? i18n.t(`helperTexts.${field.helperText}`) : '')}
                onChange={(newVal) => onChange(field.id, newVal)}
            />
        );
    }
}

DialogStaticMultiSelect.propTypes = {
    field: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    value: PropTypes.array,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

DialogStaticMultiSelect.defaultProps = {
    value: []
};
